import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

const ChatIssueTableHeaders = () => {
  return (
    <TableRow
      sx={{
        background: "#fff",
      }}
    >
      <TableCell>
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            color: "#0F2552",
          }}
        >
          Article Name / URL
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Typography
          sx={{
            fontSize: "12px",
            color: "#0F2552",
            fontWeight: 500,
          }}
        >
          Number of times referred
        </Typography>
      </TableCell>
      {/* <TableCell align="center">
        <Typography
          sx={{
            fontSize: "12px",
            color: "#0F2552",
            fontWeight: 500,
          }}
        >
          Successfull referred
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Typography
          sx={{
            fontSize: "12px",
            color: "#0F2552",
            fontWeight: 500,
          }}
        >
          Unsuccessfull referred
        </Typography>
      </TableCell> */}
    </TableRow>
  );
};

export default ChatIssueTableHeaders;
